module.exports = __webpack_public_path__ + "static/media/Search.b6a8b896.svg";